import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Elements/Modal/Modal';
import MainButton from '../Elements/MainButton/MainButton';
import SecondButton from '../Elements/SecondButton/SecondButton';
import MainInput from '../Elements/MainInput/MainInput';
import ErrorMessage from '../Elements/ErrorMessage/ErrorMessage';
import SuccessMessage from '../Elements/SuccessMessage/SuccessMessage';
import { requestRefund } from '../../services/TransactionService';
import './ProfileModals.css';  // Reuse styles

const RefundModal = ({ isOpen, onClose, transactionId, onSuccess }) => {
  const { t } = useTranslation();
  const [reason, setReason] = useState('');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const resetState = () => {
    setReason('');
    setError('');
    setSaving(false);
  };

  useEffect(() => {
    if (isOpen) resetState();
  }, [isOpen]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (!reason.trim()) {
      setError(t("profile.enterReason"));
      return;
    }

    try {
      setSaving(true);
      await requestRefund(transactionId, reason.trim());
      setSuccess(t("profile.refundSuccess", "Refund requested successfully."));
      onSuccess?.();
      setTimeout(onClose, 1500);  // Auto-close after success
    } catch (err) {
      setError(err.message || t("profile.refundFailed", "Refund request failed"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={saving ? onClose : onClose}
      title={t("profile.requestRefund")}
    >
      <form onSubmit={handleSubmit} className="profile-modal-form">
        <label>{t("transactions.columns.transactionId", "Transaction ID")}</label>
        <MainInput type="text" value={transactionId} readOnly className="profile-user-edit-input-readonly" />
        <label>{t("profile.reason")}</label>
        <MainInput
          type="text"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          placeholder={t("profile.enterReason")}
        />
        {error && (
          <div className="profile-user-edit-error">
            <ErrorMessage message={error} onClose={() => setError('')} />
          </div>
        )}
        {success && (
          <div className="profile-user-edit-success-wrapper">
            <SuccessMessage message={success} onClose={() => setSuccess('')} />
          </div>
        )}
        <div className="refund-modal-actions">
          <SecondButton onClick={onClose} disabled={saving}>{t("common.cancel")}</SecondButton>
          <MainButton onClick={handleSubmit} disabled={saving}>
            {saving ? t("profile.requesting") : t("profile.requestRefund")}
          </MainButton>
        </div>
      </form>
    </Modal>
  );
};

export default RefundModal;
